export function getToleranceClasses(t) {
  return [
    {
      label: "G 4000",
      description: t("toleranceClasses.byToleranceClass.g4000.description"),
      value: 4000,
    },
    {
      label: "G 1600", 
      description: t("toleranceClasses.byToleranceClass.g1600.description"),
      value: 1600,
    },
    {
      label: "G 630",
      description: t("toleranceClasses.byToleranceClass.g630.description"),
      value: 630,
    },
    {
      label: "G 250",
      description: t("toleranceClasses.byToleranceClass.g250.description"), 
      value: 250,
    },
    {
      label: "G 100",
      description: t("toleranceClasses.byToleranceClass.g100.description"),
      value: 100,
    },
    {
      label: "G 40",
      description: t("toleranceClasses.byToleranceClass.g40.description"),
      value: 40,
    },
    {
      label: "G 16",
      description: t("toleranceClasses.byToleranceClass.g16.description"),
      value: 16,
    },
    {
      label: "G 6.3",
      description: t("toleranceClasses.byToleranceClass.g6.3.description"),
      value: 6.3,
    },
    {
      label: "G 2.5",
      description: t("toleranceClasses.byToleranceClass.g2.5.description"),
      value: 2.5,
    },
    {
      label: "G 1.0",
      description: t("toleranceClasses.byToleranceClass.g1.0.description"),
      value: 1,
    },
    {
      label: "G 0.4",
      description: t("toleranceClasses.byToleranceClass.g0.4.description"),
      value: 0.4,
    },
  ];
}

export function getToleranceClassesByRotor(t) {
  return [
    {
      label: t("toleranceClasses.byRotor.driveCrankshaftsUnbalancedG4000.label") + " - G 4000",
      value: 4000.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.driveCrankshaftsBalancedG1600.label") + " - G 1600",
      value: 1600.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.driveCrankshaftsUnbalancedVibroG630.label") + " - G 630",
      value: 630.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.driveCrankshaftsUnbalancedRigidG250.label") + " - G 250",
      value: 250.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.reciprocatingEnginesG100.label") + " - G 100",
      value: 100.0,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.wheelsG40.label") + " - G 40",
      value: 40.0,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.wheelRimsG40.label") + " - G 40",
      value: 40.0,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.wheelSetsG40.label") + " - G 40",
      value: 40.0,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.transmissionsG40.label") + " - G 40",
      value: 40.0,
      description: "" 
    },
    {
      label: t("toleranceClasses.byRotor.driveCrankshaftsBalancedVibroG40.label") + " - G 40",
      value: 40.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.agriculturalMachinesG16.label") + " - G 16",
      value: 16.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.driveCrankshaftsBalancedRigidG16.label") + " - G 16",
      value: 16.0,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.crushersG16.label") + " - G 16",
      value: 16.0,
      description: "" 
    },
    {
      label: t("toleranceClasses.byRotor.driveShaftsG16.label") + " - G 16",
      value: 16.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.aircraftGasTurbinesG63.label") + " - G 6.3",
      value: 6.3,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.centrifugesG63.label") + " - G 6.3",
      value: 6.3,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.electricMotorsLowSpeedG63.label") + " - G 6.3",
      value: 6.3,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.smallElectricMotorsG63.label") + " - G 6.3",
      value: 6.3,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.fansG63.label") + " - G 6.3",
      value: 6.3,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.gearDrivesG63.label") + " - G 6.3",
      value: 6.3,
      description: "" 
    },
    {
      label: t("toleranceClasses.byRotor.generalMachinesG63.label") + " - G 6.3",
      value: 6.3,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.metalCuttingMachinesG63.label") + " - G 6.3",
      value: 6.3,
      description: "" 
    },
    {
      label: t("toleranceClasses.byRotor.paperMachinesG63.label") + " - G 6.3",
      value: 6.3,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.pumpsG63.label") + " - G 6.3",
      value: 6.3,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.turbochargersG63.label") + " - G 6.3",
      value: 6.3,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.waterTurbinesG63.label") + " - G 6.3",
      value: 6.3,
      description: "" 
    },
    { 
      label: t("toleranceClasses.byRotor.compressorsG25.label") + " - G 2.5",
      value: 2.5,
      description: "" 
    },
    {
      label: t("toleranceClasses.byRotor.computerControlledDrivesG25.label") + " - G 2.5",
      value: 2.5,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.electricMotorsHighSpeedG25.label") + " - G 2.5",
      value: 2.5,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.gasSteamTurbinesG25.label") + " - G 2.5",
      value: 2.5,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.machineDrivesG25.label") + " - G 2.5",
      value: 2.5,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.textileMachinesG25.label") + " - G 2.5",
      value: 2.5,
      description: "" 
    },
    {
      label: t("toleranceClasses.byRotor.audioDrivesG10.label") + " - G 1.0",
      value: 1.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.videoDrivesG10.label") + " - G 1.0",
      value: 1.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.grindingMachineDrivesG10.label") + " - G 1.0",
      value: 1.0,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.precisionSpindlesG04.label") + " - G 0.4",
      value: 0.4,
      description: "",
    },
    {
      label: t("toleranceClasses.byRotor.precisionDrivesG04.label") + " - G 0.4",
      value: 0.4,
      description: "",
    },
    { 
      label: t("toleranceClasses.byRotor.gyroscopesG04.label") + " - G 0.4",
      value: 0.4,
      description: "" 
    },
  ].sort(
    (a, b) => (b.value - a.value) || a.label.localeCompare(b.label)
  );
}
